module.exports = __webpack_public_path__ + "static/media/ARI-PREsys S.0df95d21.jpg";